module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Gb-Db-Ef.c4dec122.png";